import { GET_RESIDENCE_LIST_SUCCESS, GET_RESIDENCE_LIST_FAILURE } from '../constants/MTag';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case GET_RESIDENCE_LIST_SUCCESS:
			return {
				...state,
				data: action.payload,
				isLoading: false,
			};
		case GET_RESIDENCE_LIST_FAILURE:
			return {
				...state,
				isLoading: false,
				errorData: action.payload,
				error: true,
			};
		default:
			return { ...state };
	}
};
